import { useCallback } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

type SanitizationOutcome = 'attempted' | 'modified' | 'unchanged' | 'failed';

interface SanitizationLogInput {
  contactId: string;
  outcome: SanitizationOutcome;
  error?: unknown;
}

export function useEmailSanitizationLogger() {
  const logSanitization = useCallback(({ contactId, outcome, error }: SanitizationLogInput): void => {
    if (outcome === 'failed') {
      datadogLogs.logger.error(
        'Email body sanitization failed',
        { channel: 'email', contactId, outcome },
        error as Error
      );
      return;
    }

    datadogLogs.logger.info('Email body sanitization', {
      channel: 'email',
      contactId,
      outcome
    });

    if (outcome === 'modified') {
      datadogLogs.logger.info('Email body sanitized', {
        contactId
      });
    }
  }, []);

  return {
    logSanitization
  };
}
